import { connect } from "react-redux";
import EditUserComponent from "../components/EditUserComponent";
import { updateUser } from "../users/actions";
import { translate } from "react-i18next";
const mapStateToProps = (state, ownProps) => {
  return {
    phase: state.account.phase,
    initialValues:
      state.account.user.userId === ownProps.match.params.id
        ? state.account.user
        : state.users.users.find(u => u.userId === ownProps.match.params.id)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: user => {
      dispatch(updateUser(user));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(EditUserComponent));



// WEBPACK FOOTER //
// ./src/containers/EditUserContainer.js